export default {
  'translation.title': 'Quản lý Ngôn ngữ (Shared I18n)',
  'translation.guide.title': 'Hướng dẫn phân loại & Quy ước đặt tên',
  'translation.guide.subtitle': 'Tìm hiểu cách đặt tên key và sử dụng biến {dynamic}',
  'translation.guide.close': 'Nhấn để thu gọn nội dung hướng dẫn',
  'translation.guide.detail': 'XEM CHI TIẾT',
  'translation.guide.collapse': 'THU GỌN',
  'translation.guide.groupTitle': 'PHÂN LOẠI NHÓM (GROUP)',
  'translation.guide.namingTitle': 'QUY ƯỚC ĐẶT TÊN KEY',
  'translation.guide.namingExample': 'Ví dụ: home.banner.title, auth.login.submit_btn',
  'translation.guide.variableTitle': 'BIẾN ĐỘNG TRONG HỆ THỐNG',
  'translation.guide.variableNote': 'Lưu ý: Cần giữ nguyên thẻ trong ngoặc nhọn khi dịch nội dung sang ngôn ngữ khác.',
  'translation.guide.noVariable': 'Chưa phát hiện biến nào từ DB',
  'translation.guide.systemVariable': 'Biến hệ thống',
  'translation.tabs.all': 'Tất cả',
  'translation.tabs.missingVi': 'Thiếu Tiếng Việt',
  'translation.tabs.missingEn': 'Thiếu Tiếng Anh',
  'translation.columns.key': 'Key',
  'translation.columns.group': 'Nhóm (Group)',
  'translation.columns.description': 'Mô tả / Ngữ cảnh',
  'translation.columns.vi': 'Tiếng Việt (VI)',
  'translation.columns.en': 'Tiếng Anh (EN)',
  'translation.columns.action': 'Thao tác',
  'translation.action.edit': 'Sửa',
  'translation.action.delete': 'Xóa',
  'translation.msg.syncSuccess': 'Đồng bộ bộ nhớ đệm thành công!',
  'translation.msg.syncFail': 'Đồng bộ thất bại',
  'translation.msg.deleteSuccess': 'Đã xóa thành công!',
  'translation.msg.deleteFail': 'Xóa thất bại',
  'translation.msg.saveSuccess': 'Lưu thành công!',
  'translation.msg.createSuccess': 'Thêm mới thành công!',
  'translation.msg.updateSuccess': 'Cập nhật thành công!',
  'translation.msg.importSuccess': 'Đã nhập thành công {count} bản dịch!',
  'translation.msg.exportSuccess': 'Xuất dữ liệu thành công!',
  'translation.msg.importFail': 'Nhập dữ liệu thất bại: {error}',
  'translation.msg.invalidFormat': 'Định dạng file không hợp lệ (phải là mảng)',
  'translation.confirm.delete': 'Bạn có chắc chắn muốn xóa key này?',
  'translation.confirm.permanentDelete': 'Bạn hoàn toàn chắc chắn muốn xóa vĩnh viễn key này?',
  'translation.drawer.editTitle': 'Chi tiết bản dịch',
  'translation.drawer.createTitle': 'Thêm Key mới',
  'translation.drawer.statusTitle': 'Trạng thái',
  'translation.drawer.statusEditing': 'Đang chỉnh sửa bản dịch hiện có',
  'translation.drawer.statusCreating': 'Đang tạo bản dịch mới cho hệ thống',
  'translation.drawer.keyLabel': 'Translation Key (Định danh)',
  'translation.drawer.keyTooltip': 'Key duy nhất dùng để truy xuất bản dịch trong mã nguồn.',
  'translation.drawer.groupLabel': 'Nhóm (Group)',
  'translation.drawer.contentSection': 'NỘI DUNG DỊCH',
  'translation.drawer.noteSection': 'GHI CHÚ',
  'translation.drawer.deletePermanentBtn': 'Xóa bản dịch này khỏi hệ thống',
  'translation.toolbar.export': 'Xuất File',
  'translation.toolbar.import': 'Nhập File',
  'translation.toolbar.sync': 'Sync Cache',
  'translation.toolbar.add': 'Thêm mới',
  'translation.search.search': 'Tìm kiếm',
  'translation.search.reset': 'Làm lại',
  'translation.search.expand': 'Mở bộ lọc',
  'translation.search.collapse': 'Thu gọn',
  'translation.group.all': 'Tất cả (All)',
  'translation.noDescription': 'Chưa có mô tả',
};
